import { render, staticRenderFns } from "./chart-card.vue?vue&type=template&id=95c1b09e&scoped=true"
import script from "./chart-card.vue?vue&type=script&lang=ts"
export * from "./chart-card.vue?vue&type=script&lang=ts"
import style0 from "./chart-card.vue?vue&type=style&index=0&id=95c1b09e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c1b09e",
  null
  
)

export default component.exports